export default "__VITE_ASSET__067c746a__"